export default "__VITE_ASSET__DNlgForr__";